<template>
    <span class="cursor-pointer fw-bold text-success action-text">{{ str }}</span>
</template>
<script setup lang="ts">
defineProps({
    str: { type: String, required: true },
})

</script>
<style scoped>
.action-text {
    text-decoration: none;
}
.action-text:hover {
    text-decoration: underline;
}
</style>